import {useState} from 'react'
import ServiceMasterForm from './ServiceMasterForm';
import ServiceMasterList from './ServiceMasterList';

const ServiceMaster = () => {
    const [fromIsShown, setFromIsShown] = useState(false);
    const [upData, setUpData] = useState(false);
    const [serviceId, setServiceId] = useState("none");
  
  return (
    <>
      {fromIsShown ? (
          <ServiceMasterForm addForm={setFromIsShown} update={upData} sId={serviceId}/>
        ) : (
          <ServiceMasterList addForm={setFromIsShown} update={setUpData} sId={setServiceId}/>
        )}
  
    </>
  )
}

export default ServiceMaster